import React ,{Component} from 'react';
import { Navigate  } from 'react-router-dom';
import axios from 'axios';

import Button from '@mui/material/Button';
import { styled } from '@mui/system';


import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';



import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import ReactToPrint from 'react-to-print';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
//import { styled } from '@mui/material/styles';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(100%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 100,
});


const useStyles = styled({   
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
  

  table: {
    minWidth: 750,
  },
  
});



function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}


function getSorting(order, orderBy) {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}



export default class FileUpload extends Component {
	
    constructor(props) {
    super(props);
	
 this.state = {
		  preview1: '',
    se_file: '',erropen:false,
    addopen: false,  
    btndisabled: false,btntext:'Save',errortype:"error",errormessage:"",
    prevaddfile: '',
	}
	      
	}
	
	



	onaddFileChange=(e) =>{   	 
	   
	
	 let imageFile = e.target.files[0];
	 let size = e.target.files[0].size;
   if (!imageFile.name.match(/\.(png|jpeg|jpg|doc|pdf|docx)$/)) {

  this.setState({errormessage:"Please Upload File (png,jpeg,jpg,doc,pdf,docx).",erropen:true});
		 window.scrollTo({        top: 0     })
	
  
    return false;
  }else{
        this.setState({preview1:URL.createObjectURL(e.target.files[0]), se_file: e.target.files })
  }
	
		
    }
	
	
  handleaddfileClose = () => {
    this.setState({
      addopen: !this.state.addopen, 
    });
  };
	
  handleSubmit= (event) => {

    event.preventDefault();
let sefile=this.state.se_file;
if(sefile==="")
{
  this.setState({errormessage:"Please Upload File",erropen:true});
   window.scrollTo({        top: 0     })
   return false;
}
  var formData = new FormData();
   formData.append('action','uploadfile')
    	 formData.append('se_id',this.props.id)
		 	 // formData.append('userid',localStorage.getItem("PSUid"))
		 	  formData.append('userid',1)
	 if(this.state.se_file!=="")
	  {
		
		for (const key of Object.keys(this.state.se_file)) {
            formData.append('Filedata', this.state.se_file[key])
        }
 	
	   formData.append('se_file','1')		
	  }else
	  {
		 formData.append('se_file',this.state.prevaddfile)	  
	  
	  }
	    formData.append('strrtype',this.props.strrtype);
	  
	    this.setState({btndisabled:true,btntext:"Processing..."})
	axios.post(localStorage.getItem("ISIurl")+"ajaxsalesestimate.php", formData, {
        })
		this.setState({btndisabled:false,btntext:'Save',erropen:false,errormessage:'',addopen:false});
		
		
	
	
  }
handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  }
	render() {
		
		
		
    return (
  <React.Fragment>
  
    <Dialog
            open={this.state.addopen}  
            onClose={this.handleClose}
            maxWidth="xs"
            fullWidth={true}
          >
            <DialogTitle id="form-dialog-title" className="dialoghead">
           
            
            </DialogTitle>
            <DialogContent>
    
<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity={this.state.errortype}
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
          <div className="addfile">
            <div className="uploadbtn">
             <p>Upload File</p>
              <p> <Button
                component="label"
                className="frmSecondarybtn"
                name="se_file"
                onChange={this.onaddFileChange}
                variant="contained"
                accept="image/*;capture=camera"
                startIcon={<CloudUploadIcon />}
              >
                <VisuallyHiddenInput type="file" />
              </Button></p> 
            </div>

            <div className="actionbtns">
              <div className="cancelbtn">
                <Button
                  variant="contained"
                  className="frmthirdbtn"
                  onClick={this.handleaddfileClose} 
                >
                  Close
                </Button>
              </div>
              <div className="savebtn">
                <Button disabled={this.state.btndisabled}
                  variant="contained"
                  className="frmSecondarybtn"
                  onClick={this.handleSubmit}
                >
                  {this.state.btntext}
                </Button>
              </div>
              <div className="clear"></div>
            </div>
          </div>
        
		      </DialogContent>
          </Dialog>
      </React.Fragment>
    );
}

}